<script setup lang="ts">
import { faClose } from '@fortawesome/pro-regular-svg-icons';

const { bottomSpace = 64 } = defineProps<{ bottomSpace?: number }>();

const vpnNotice = useVpnNotice();

const bottomSpacePx = computed(() => `${bottomSpace}px`);
const closed = useSessionStorage('VPN_NOTICE', false);

function close() {
    closed.value = true;
}
</script>
<template>
    <ClientOnly>
        <div v-if="vpnNotice && !closed" class="container">
            <img src="~/assets/files/vpn_logo.svg" />

            <mr-typography
                :size="{
                    desktop: 'small',
                    mobile: 'x-small',
                }"
                :weight="{
                    desktop: '500',
                    mobile: '400',
                }"
                color="var(--yellow-700)"
            >
                برای دسترسی بهتر و ایمن به خدمات سایت، لطفاً اتصال فیلترشکن خود
                را قطع نمایید و مجدداً تلاش کنید.
            </mr-typography>
            <div class="spacer" />
            <mr-button
                size="small"
                :icon-button="faClose"
                color="secondary"
                variant="transparent"
                @click="close"
            />
        </div>
    </ClientOnly>
</template>
<style scoped lang="scss">
.container {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 12px;
    padding: 8px 12px;
    background-color: usePalette($p-yellow, $p-200);
    position: sticky;
    bottom: 20px;
    flex-basis: 75%;
    flex-grow: 75;
    left: 0;
    width: 100%;
    max-width: 888px;
    z-index: 8000;
    @include mobile-only {
        bottom: v-bind(bottomSpacePx);
        width: 100%;
    }
    .spacer {
        flex-grow: 1;
    }
    .login {
        white-space: nowrap;
        flex-shrink: 0;
    }
    :deep(.icon) {
        color: usePalette($p-yellow, $p-700) !important;
    }
}
</style>
